import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Meta from '../components/Meta';
import { FAQPageSchema } from '../components/StructuredData';
import ResponsiveImage from '../components/ResponsiveImage';

export default function FAQ() {
  const { t } = useTranslation();

  const faqs = t('faq.questions', { returnObjects: true });

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <Meta titleKey="faq.meta.title" descKey="faq.meta.description" />
      <FAQPageSchema faqs={faqs} />

      <section className="bg-gray-100 rounded-xl p-8 mb-10 flex flex-col md:flex-row justify-between items-center">
        <div className="md:w-3/4">
          <h1 className="font-bold text-h2 md:text-h1 mb-4 font-rubik">
            {t('faq.heading')}
          </h1>
          <p className="font-rubik text-body">
            {t('faq.intro')}
          </p>
        </div>

        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mt-6 md:mt-0"
        >
          <ResponsiveImage
            srcBase="/images/feature-2"
            alt={t('faq.imageAlt')}
            className="block mx-auto w-32 md:w-40 lg:w-48 drop-shadow-xl"
            loading="lazy"
          />
        </motion.div>
      </section>

      <section className="space-y-4">
        {faqs.map((faq, index) => (
          <details key={index} className="border-b border-gray-300 pb-4">
            <summary className="cursor-pointer font-medium text-body font-rubik text-gray-800">
              {faq.question}
            </summary>
            <p className="mt-2 font-rubik text-body text-gray-600">
              {faq.answer}
            </p>
          </details>
        ))}
      </section>
    </div>
  );
}
